import { render, staticRenderFns } from "./PsPageNotFound.vue?vue&type=template&id=3bf914f8&scoped=true&"
import script from "./PsPageNotFound.vue?vue&type=script&lang=js&"
export * from "./PsPageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf914f8",
  null
  
)

export default component.exports